import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilesService } from '@check-list/app/shared/services/files/files.service';
import { CommonService } from '@check-list/app/shared/services/common/common.service';
import { UploadFile } from '@check-list/core/models/upload-file.model';

@Component({
  selector: 'authority-labs-upload-queue',
  templateUrl: './upload-queue.component.html',
  styleUrls: ['./upload-queue.component.scss']
})
export class UploadQueueComponent implements OnInit {
  @Input() uploadList: UploadFile[];
  @Input() showProgress = true;
  @Output() removedItem = new EventEmitter<UploadFile>();
  hoveredItem: UploadFile;

  translatePath = 'fileStorage.';
  translatePaths = {
    queue: `${this.translatePath}queue.`,
    messages: `${this.translatePath}messages.`,
    uploadZone: `${this.translatePath}uploadZone.`
  };
  format = (percent) => (percent === 100 ? '' : '');

  constructor(
    private filesService: FilesService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    if (!this.uploadList) {
      this.uploadList = this.filesService.fileList;
    }
  }

  view(data: UploadFile) {
    const uploadedFile = this.uploadList.find(
      (x) => x.file.uid === data.file.uid
    );
    const folderId = uploadedFile.uploadZone.id;
    const fileName = data.file.name;

    this.commonService.viewFile(folderId, fileName);
  }

  removeItem(data: UploadFile) {
    this.removedItem.emit(data);
  }

  showDeleteFileButton(uploadFile: UploadFile) {
    return (
      !uploadFile.isCancelled &&
      uploadFile.file.status !== 'done' &&
      (!uploadFile.file.percent || uploadFile.file.percent < 95)
    );
  }

  reUpload(uploadFile: UploadFile) {
    this.filesService.reUpload(uploadFile);
  }
}
